<template>
  <div class="content-page">
    <div class="tab-content">
      <el-form :model="shopForm" :rules="shopFormRules" ref="shopForm" label-width="124px" class="shopsetting-form"
        width="328px" :hide-required-asterisk="true">
        <div class="inline-title">小程序</div>
        <el-form-item label="">
          支持微信买单，支付宝买单
          <el-button type="primary" size="small" @click="
            $router.push({
              path: '/applt',
            })
            ">去配置</el-button>
        </el-form-item>
        <div class="inline-title">发视频</div>
        <el-form-item label="">
          支持抖音，快手,小红书视频发布
          <el-button type="primary" size="small" @click="
            $router.push({
              path: '/marketingActivity',
            })
            ">去配置</el-button>
        </el-form-item>
        <div class="inline-title">打卡点评</div>
        <el-form-item label="大众点评店铺链接">
          <el-input v-model="shopForm.dianpingUrl" placeholder="请输入大众点评店铺链接" type="text"></el-input>
        </el-form-item>
        <el-form-item label="高德店铺链接">
          <el-input v-model="shopForm.gdShareUrl" placeholder="请输入高德店铺链接" type="text"></el-input>
        </el-form-item>
        <el-form-item label="抖音店铺链接">
          <el-input v-model="shopForm.dyShopShareUrl" placeholder="请输入抖音店铺链接" type="text"></el-input>
        </el-form-item>
        <div class="inline-title">碰一碰引流</div>
        <el-form-item label="二维码">
          <div class="img-box">
            <qrcode :value="shopForm.nfcBdmPageUrl" :options="{ size: 300 }" class="scan-code-img" id="nfcPageUrlImage">
            </qrcode>
            <el-button type="primary" size="small" @click="downCode('nfcPageUrlImage')">下载</el-button>
          </div>
        </el-form-item>
        <el-form-item label="链接">
          <span>
            <input style="position: absolute; top: 0; left: 0; opacity: 0" :value="shopForm.nfcBdmPageUrl"
              id="nfcPageUrlText" />
            {{ shopForm.nfcBdmPageUrl }} &nbsp;</span>
          <el-button type="primary" size="small" @click="copy('nfcPageUrlText')">复制</el-button>
          <span>
            &nbsp;
            <i class="el-icon-warning-outline"></i>
            链接用途:写入到NFC卡中。给用户碰一碰使用。</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('shopForm')">保存</el-button>
        </el-form-item>
      </el-form>
      <uploadImgComponent :isshow_uploadDialog="isshow_uploadDialog" @onClose="close_uploadDialog"
        @getChoose_ImgUrl="getChoose_ImgUrl" ref="childRef" :ImgLimits="ImgLimits" :uploadName="uploadName">
      </uploadImgComponent>
    </div>
  </div>
</template>

<script>
import {
  uploadVideo,
  uploadImg,
  modifyShopInfo,
  uploadFile,
  getShopInfo,
} from "@/api/index.js";
import { mapState, mapActions } from "vuex";
import uploadImgComponent from "@/components/uploadImg";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import qrcode from "@xkeshi/vue-qrcode";

export default {
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      introduceVideoUrl: [],
      shopForm: {
        dianpingUrl: "",
        gdShareUrl: "",
        dyShopShareUrl: "",
        nfcBdmPageUrl: "",
      },
      shopFormRules: {},
      videoHomeImage: [],
      isshow_uploadDialog: false,
      uploadDisabled: false,
      shopImages: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ size: ["small", false, "large", "huge"] }],
            [{ font: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ header: 1 }, { header: 2 }],
            ["image"],
            [{ direction: "rtl" }], //文字编辑方向，从左到右还是从右到左
            [{ color: [] }, { background: [] }],
          ],
        },
        placeholder: "请输入内容...",
      },
      ImgLimits: 0,
      uploadName: "",
      shopkeeperWechat: [],
      attrValueInputVisible: false,
      attrValueInputValue: "",
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  components: {
    uploadImgComponent,
    quillEditor,
    qrcode,
  },
  mounted() {
    let url = window.location.href;
    if (this.$refs.myQuillEditor) {
      this.$refs.myQuillEditor.quill
        .getModule("toolbar")
        .addHandler("image", this.imgHandler);
    }
    getShopInfo().then((shopInfo) => {
      console.log(shopInfo);
      Object.assign(this.shopForm, shopInfo.data);
    });
  },
  methods: {
    copy(name) {
      var copyText = document.getElementById(name);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    downCode(name) {
      let canvas = document.getElementById(name);
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = `${name}.png`; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
    handleClose(index) {
      this.shopForm.videoHomeVideoIds.splice(index, 1);
    },
    handleAttrValueInputConfirm() {
      let attrValueInputValue = this.attrValueInputValue;
      if (attrValueInputValue) {
        this.shopForm.videoHomeVideoIds.push(attrValueInputValue);
      }
      this.attrValueInputVisible = false;
      this.attrValueInputValue = "";
    },

    showAttrValueInput() {
      this.attrValueInputVisible = true;
      this.$nextTick((_) => {
        this.$refs[`saveTagInput`].focus();
      });
    },
    handleRemoveVideo() {
      this.shopForm.introduceVideoUrl = "";
    },
    handleSuccessVideo(res) {
      let videoUploadForm = new FormData();
      videoUploadForm.append("file", res.file);
      videoUploadForm.append("fileContentType", res.file.type);
      videoUploadForm.append("fileFileName", res.file.name);
      videoUploadForm.append("isCompre", 1);
      videoUploadForm.append("isCutImage", 1);
      uploadVideo(videoUploadForm).then((res) => {
        if (res.code == 1) {
          this.shopForm.introduceVideoUrl = res.data.url;
        }
      });
    },
    getChoose_ImgUrl(val, name) {
      console.log(val, name);
      // return
      if (val.length > 0) {
        if (this[name].length >= this.ImgLimits) {
          return this.$notify.warning("所选图片已达限制");
        }
        this.isshow_uploadDialog = false;
        this.uploadDisabled = false;
        val.forEach((item) => {
          if (name == "shopImages") {
            this.shopForm.introduceImages += `,${item.image}`;
            if (this.shopForm.introduceImages.substr(0, 1) == ",")
              this.shopForm.introduceImages = this.shopForm.introduceImages.substr(1);
            this.shopImages.push({ name: "", url: item.image });
          } else if (name == "videoHomeImage") {
            this.shopForm.videoHomeImage = `${item.image}`;
            this.videoHomeImage.push({ name: "", url: item.image });
          } else if (name == "shopkeeperWechat") {
            this.shopForm.shopkeeperWechat = `${item.image}`;
            this.shopkeeperWechat.push({ name: "", url: item.image });
          }
        });
      }
      // this.$refs["shopForm"].validate();
    },
    ...mapActions(["updateShopInfo"]),
    handleRemove(file, name) {
      console.log(file, name);
      if (name == "shopImages") {
        let shopImages1 = this.shopForm.introduceImages.split(",");
        let shopImages2 = this.shopForm.introduceImages.split(",");
        shopImages1.splice(shopImages1.indexOf(file.url), 1);
        this.shopForm.introduceImages = shopImages1.join(",");
        this.shopImages.splice(shopImages2.indexOf(file.url), 1);
      } else {
        this.shopForm[name] = "";
        this[name] = [];
      }
    },
    beforeRemove(file, fileList) { },
    beforeImgUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isJPG = types.includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(item, name) {
      console.log(item, "上传成功");
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("isCompre", 1);
      imgUploadForm.append("isCutImage", 1);
      uploadImg(imgUploadForm).then((res) => {
        if (res.code == 1) {
          console.log(res, "上传成功");
          // this.shopForm.introduceImages += `,${item.image}`
          // if (this.shopForm.introduceImages.substr(0,1) == ',')  this.shopForm.introduceImages=this.shopForm.introduceImages.substr(1);
          //   if (name == "shopImages") {
          //     if (this.shopForm[name].length) {
          //       this.shopForm[name] += `,${res.data.url}`;
          //     } else {
          //       this.shopForm[name] = res.data.url;
          //     }
          //     return;
          //   }
          //   this.shopForm[name] = res.data.url;
        }
      });
    },
    imgHandler(state) {
      if (state) {
        this.$refs.fileBtn.click();
      }
    },
    handleUpload(e) {
      console.log(e, 123);
      const files = Array.prototype.slice.call(e.target.files);
      // console.log(files, "files")
      if (!files) {
        return;
      }
      let formdata = new FormData();
      formdata.append("file", files[0]);
      uploadFile(formdata).then((res) => {
        console.log(res, 789);
        if (res.data.url) {
          let selection = this.$refs.myQuillEditor.quill.getSelection();
          //这里就是返回的图片地址，如果接口返回的不是可以访问的地址，要自己拼接
          let imgUrl = res.data.url;
          //获取quill的光标，插入图片
          this.$refs.myQuillEditor.quill.insertEmbed(
            selection != null ? selection.index : 0,
            "image",
            imgUrl
          );
          //插入完成后，光标往后移动一位
          this.$refs.myQuillEditor.quill.setSelection(selection.index + 1);
        }
      });
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
    },
    submitForm(formName, cb) {
      console.log(this.shopForm, "shopForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let shopForm = JSON.parse(JSON.stringify(this.shopForm));
          shopForm.isNfcBdm = 1;
          modifyShopInfo(shopForm).then((res) => {
            console.log(123);
            if (res.code == 1) {
              getShopInfo().then((shopInfo) => {
                this.updateShopInfo(shopInfo.data);
                if (cb) {
                  cb(shopInfo.data);
                  return;
                }
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    close_uploadDialog() {
      this.isshow_uploadDialog = false;
      this.uploadDisabled = false;
    },
    show_uploadDialog(val, name) {
      console.log(val, name);
      this.ImgLimits = val;
      this.uploadName = name;
      this.isshow_uploadDialog = true;
      this.uploadDisabled = true;
      this.$refs.childRef.rSelect = []; //  每次打开清除上一次的选择
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .avatar {
  width: 300px;
  height: 300px;
}

/deep/ .ql-editor {
  width: 50%;
  min-height: 300px;
}

.content-page {
  .tab-header {
    padding: 12px 20px;
  }

  .tab-content {
    // padding: 40px 48px;
  }

  .shopsetting-form {
    width: 100%;

    .el-tag {
      margin-right: 10px;
    }

    .qrcode-img {
      display: inline-block;
      position: relative;
      left: 0px;
      bottom: 0px;
      width: 300px;
      height: 450px;
      margin-right: 10px;

      .bg {
        width: 100%;
        height: 100%;
      }

      .logo {
        position: absolute;
        width: 30px;
        height: 30px;
        right: 136px;
        left: 140.5px;
        top: 243px;
        border-radius: 4px;
      }

      .name {
        position: absolute;
        display: block;
        width: 172px;
        color: #d07910;
        font-size: 10.8px;
        bottom: 64px;
        left: 72px;
        text-align: center;
      }

      .phone {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 35px;
        left: 0;
        text-align: center;
        font-weight: bold;
      }

      .addresss {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 17px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
        white-space: nowrap;
        overflow: hidden;
      }

      .info {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: -1px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
      }

      .scan-code-img {
        position: absolute;
        display: block;
        bottom: 147px;
        left: 111px;
      }
    }

    .el-form-item__content {

      .el-input,
      .el-textarea,
      .el-cascader {
        width: 380px;
      }

      .taxnum-input {
        width: 200px;
        margin-right: 10px;
      }

      .el-date-editor {
        width: 182px;
        margin-right: 14px;
      }

      .func-container {
        width: 144px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        margin-right: 20px;
      }

      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #f56c6c;
        margin-left: 10px;

        &>i {
          margin-right: 6px;
        }

        .el-link {
          font-size: 14px;
          vertical-align: baseline;
          margin-left: 10px;
        }
      }

      .verified-status {
        margin-right: 18px;
      }
    }

    .submit-btn-container {
      margin: 40px 0 200px 0;
    }

    .inline-title {
      line-height: 40px;
      font-size: 14px;
      color: #333333;
      padding-left: 20px;
      background: #f8f8f8;
      margin: 0 0 24px 0;
    }

    .el-radio {
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .img-box {
    display: flex;
    align-items: center;

    .el-button {
      margin-left: 100px;
    }

    .scan-code-img {
      width: 150px;
      height: 150px;
    }
  }
}

.map {
  width: 100%;
  height: 400px;

  /deep/ .anchorBL {
    display: none;
  }
}
</style>
